import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_EDIT_NAME_OPEN = "CE_MODAL_EDIT_NAME_OPEN";
export const ceModalEditNameOpen = (clientContentID) => ({
  type: CE_MODAL_EDIT_NAME_OPEN,
  client_content_id: clientContentID,
});

export const CE_MODAL_EDIT_NAME_SAVE = "CE_MODAL_EDIT_NAME_SAVE";
export const ceModalEditNameSave = () => ({
  type: CE_MODAL_EDIT_NAME_SAVE,
});

export const ceModalEditNameCancel = () => ({
  type: CE_MODAL_CLOSE,
});
